import SectionHeading from "@/components/base/SectionHeading";
import { editorPicks } from "@/mocks/home";

export default function EditorPicks() {
  return (
    <section id="picks" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          align="center"
          eyebrow="编辑精选推荐"
          title="编辑精选：挑选理由写在每张卡片上"
          description="不只有片名，我们还写清了推荐的原因，包括字幕翻译风格、适合的观看场景，帮你判断它到底合不合口味。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {editorPicks.map((item) => (
            <article
              key={item.title}
              className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-56 w-full overflow-hidden md:h-64">
                <img
                  src={item.image}
                  alt={`${item.title} 中文字幕作品主题配图`}
                  title={`${item.title} 中文字幕高清资源`}
                  className="h-full w-full object-top"
                />
                <span className="absolute left-3 top-3 flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-1 font-label text-xs font-semibold text-foreground-800">
                  <i className="ri-star-fill text-accent-600" aria-hidden="true"></i>
                  {item.rating}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-primary-500/90 px-2.5 py-1 font-label text-xs font-medium text-background-50">
                  {item.region}
                </span>
              </div>

              <div className="p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.year}</span>
                </div>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-background-200 bg-background-100 px-2.5 py-1 font-label text-xs font-medium text-foreground-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}